import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as LaundryMachineIcon} from '../../components/svgs/laundrymachineicon.svg';
import {ReactComponent as ShippingBoxIcon} from '../../components/svgs/shippingboxicon.svg';
import {ReactComponent as CloudCheckIcon} from '../../components/svgs/cloudCheckIcon.svg';
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';

import { Link } from 'react-router-dom';
import DropdownSVG from '../../components/OrderDropdown';

const options = [
    { label: 'Edit Order', link: '#' },
    { label: 'Duplicate Order', link: '#' },
    { label: 'Print Details', link: '#' },
    { label: 'Archive Orders', link: '#' }
  ];



const ManagerOrderTab = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'In Laundry',
      icon: <LaundryMachineIcon/>,
      tableData: [
        { orderNo: '#23', customer: 'Geller Industries', commercialCustomerRep: 'Ross Geller', status: 'Washing', bags: 3, size: 119, dueDate: '06/27/23', viewButton: '/manager/orders/order-details' },
        { orderNo: '#11', customer: 'Phoebe Buffay', status: 'Drying', bags: 3, size: 200, dueDate: '06/27/23' },
        { orderNo: '#16', customer: 'Tribianni & Sons Ltd.', commercialCustomerRep: 'Joey Tribianni', status: 'Folding', bags: 4, size: 145, dueDate: '06/27/23' },
        { orderNo: '#65', customer: 'Monica’s Inc', commercialCustomerRep: 'Monica’s Geller-Bing', status: 'Binned', bags: 12, size: 134, dueDate: '06/27/23' },
        { orderNo: '#108', customer: 'Chandler Bing', status: 'Folding', bags: 16, size: 119, dueDate: '06/27/23' },
        { orderNo: '#218', customer: 'Marcel Geller', status: 'Washing', bags: 0, size: 0, dueDate: '06/27/23' },
      ]
    },
    {
      title: 'Ready for pickup',
      icon: <ShippingBoxIcon/>,
      tableData: [
        // Add data for Tab 2
        { orderNo: '001', customer: 'John Doe', status: 'Pending', bags: 2, size: 10, viewButton: '#' },
        { orderNo: '002', customer: 'Jane Smith', status: 'Completed', bags: 3, size: 15 },
      ]
    },
    {
      title: 'Picked up',
      icon: <CloudCheckIcon/>,
      tableData: [
        // Add data for Tab 3
      ]
    }
  ];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <div className="tab-container">

        <div className="tab-titles">
        {tabs.map((tab, index) => (
            <div
            key={index}
            className={`tab-title ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            >
            <div className={`tab-icon ${activeTab === index ? 'active' : ''}`}>
                {React.cloneElement(tab.icon, {
                className: activeTab === index ? 'active-icon' : ''
                })}
            </div>
            <div className={`tab-label ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
            </div>
        ))}
        </div>

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                    Order No.
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>
                  <th className=''>
                    Customer
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>
                  <th>
                    Status
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    No of Bags
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    Size (lbs)
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    Due Date
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.orderNo}
                      
                    </td>
                   
                    <td className='table-data-1'>
                      {data.customer}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.status}
                    
                    </td>
                    <td className='table-data'>
                      {data.bags}
                    
                    </td>
                    <td className='table-data'>
                      {data.size}
                   
                    </td>
                    <td className='table-data'>
                      {data.dueDate}
                   
                    </td>
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    <td>
                    <DropdownSVG options={options} className="my-dropdown" />
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default ManagerOrderTab